import * as yup from 'yup';

import PaymentPresenter from '../presenters/Membership/PaymentPresenter';
import { REQUIRED } from '../forms/errorsText.js';

export const validationFields = {
  paymentType: yup.string().required(REQUIRED),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = (payment) => {
  return {
    paymentType: PaymentPresenter.paymentType(payment) || '',
  };
};
